const Header = () => {
  return (
    <>
      <h1>— Gif in touch with your feelings! —</h1>
      <div className="intro wrapper">
        <h2>Express how you feel using gifs! </h2>
        <p>
          In the search bar below, tell us how you’re feeling, then pick the gif that best expresses
          your emotions. You can also view other users’ emotions on the timeline below!
        </p>
      </div>
    </>
  );
};

export default Header;
